import React, { FC, useEffect, useMemo } from "react"
import "./StudentDashboardPendingCertificateModal.scss"
import { Modal } from "react-bootstrap"
import { IPathInteraction } from "app_events/interaction/types"
import TextComponent from "app_components/commons/TextComponent/TextComponent"
import ButtonComponent from "app_components/commons/Button/ButtonComponent"
import { Link } from "react-router-dom"
import { routingService } from "app_services/routingService"
import { IoIosCloseCircleOutline } from "react-icons/io"
import CertificateService from "app_services/user/certificateService"

interface IStudentDashboardPendingCertificateModalProps {
  open: boolean
  onClose: () => void
  path?: IPathInteraction
}

const StudentDashboardPendingCertificateModal: FC<IStudentDashboardPendingCertificateModalProps> = ({
  open,
  onClose,
  path,
}) => {
  const certificateService = useMemo(() => new CertificateService(), [])

  const updateStatus = async () => {
    if (!path?.pendingCertificate?._id) return
    await certificateService.changeUserNotified(path?.pendingCertificate?._id, true)
  }

  useEffect(() => {
    updateStatus()
  }, [])

  if (!path) return null
  const { pendingCertificate } = path

  return (
    <Modal
      show={open}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName='student-dashboard-pending-certificate-moda--dialog'
    >
      <Modal.Body>
        <div className="student-dashboard-pending-certificate-modal--layout">
          <IoIosCloseCircleOutline onClick={onClose} className="student-dashboard-pending-certificate-modal--close-icon" />
          <TextComponent type="subtitle" >¡Nuevo Certificado Disponible!</TextComponent>
          <TextComponent fontWeight={500} fontSize='1.125rem' textAlign="center">¡Felicidades por tu nuevo logro!</TextComponent>
          <TextComponent>
            Tu certificado "{pendingCertificate?.certificateSetting?.certificateName}" esta listo para ser generado.
          </TextComponent>
          <div>
            <TextComponent color="#333333">
              <strong>
                Por favor sigue los siguientes pasos para generarlo:
              </strong>
            </TextComponent>
            <ol>
              <li>Ve a la sección de certificados haciendo click <Link to={routingService.getSecurePath('?section=certifications')} style={{ textDecoration: 'underline', cursor: 'pointer' }}><span onClick={onClose}>aquí</span></Link>.</li>
              <li>Selecciona el certificado.</li>
              <li>Completa el proceso.</li>
            </ol>
          </div>
          <Link to={routingService.getSecurePath('?section=certifications')}>
            <ButtonComponent onClick={onClose} variant="primary" >Ir a certificados</ButtonComponent>
          </Link>
          <TextComponent color="#333333">¡No pierdas la oportunidad de destacar tus logros!</TextComponent>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default StudentDashboardPendingCertificateModal
